import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-4"
};
const _hoisted_2 = { class: "text-xs text-gray-500 mb-2 font-medium" };
const _hoisted_3 = { class: "space-y-2" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "flex items-center gap-1.5 text-xs text-gray-400 mt-4" };
const _hoisted_6 = {
    key: 0,
    class: "flex items-end gap-2"
};
import { toRef } from 'vue';
import ChatMessage from './ChatMessage.vue';
import { useChatScroll } from '../composables/useChatScroll';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatMessages',
    props: {
        messages: {},
        isTyping: { type: Boolean },
        streamingMessageId: { default: null },
        shouldShowWelcome: { type: Boolean },
        shouldShowQuickActions: { type: Boolean },
        quickActions: {},
        canCreateItineraries: { type: Boolean, default: true }
    },
    emits: ["quickAction", "openDraft", "retry"],
    setup(__props) {
        const props = __props;
        const messagesRef = toRef(props, 'messages');
        const { scrollContainer, handleScroll } = useChatScroll(messagesRef);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "scrollContainer",
                ref: scrollContainer,
                class: "flex-1 overflow-y-auto px-4 py-4 space-y-4 bg-gray-50",
                onScroll: _cache[4] || (_cache[4] =
                    //@ts-ignore
                    (...args) => (_unref(handleScroll) && _unref(handleScroll)(...args)))
            }, [
                (__props.shouldShowWelcome)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (msg) => {
                            return (_openBlock(), _createBlock(ChatMessage, {
                                key: msg.id,
                                message: msg,
                                "can-create-itineraries": __props.canCreateItineraries,
                                onOpenDraft: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('openDraft', $event))),
                                onRetry: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('retry', $event)))
                            }, null, 8, ["message", "can-create-itineraries"]));
                        }), 128)),
                        (__props.shouldShowQuickActions)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("chatbot.auto.acciones_rapidas")), 1),
                                _createElementVNode("div", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.quickActions, (action) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: action.id,
                                            type: "button",
                                            class: "w-full text-left px-4 py-2.5 text-sm bg-white border border-gray-200 rounded-xl hover:border-eorange-300 hover:bg-eorange-50 transition-colors text-gray-700",
                                            onClick: ($event) => (_ctx.$emit('quickAction', action))
                                        }, _toDisplayString(action.label), 9, _hoisted_4));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_5, [
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "w-1.5 h-1.5 bg-egreen-500 rounded-full inline-block" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t("chatbot.auto.equipo_disponible_24_7")), 1)
                        ])
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (msg) => {
                            return (_openBlock(), _createBlock(ChatMessage, {
                                key: msg.id,
                                message: msg,
                                "is-streaming": msg.id === __props.streamingMessageId,
                                "can-create-itineraries": __props.canCreateItineraries,
                                onOpenDraft: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('openDraft', $event))),
                                onRetry: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('retry', $event)))
                            }, null, 8, ["message", "is-streaming", "can-create-itineraries"]));
                        }), 128)),
                        (__props.isTyping)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                                    _createStaticVNode("<div class=\"w-8 h-8 rounded-full bg-eblue-100 text-eblue-500 flex items-center justify-center flex-shrink-0\"><span class=\"text-xs font-bold\">E</span></div><div class=\"bg-gray-100 rounded-2xl rounded-bl-md px-4 py-3\"><div class=\"flex gap-1\"><span class=\"w-2 h-2 bg-gray-400 rounded-full animate-bounce\" style=\"animation-delay:0ms;\"></span><span class=\"w-2 h-2 bg-gray-400 rounded-full animate-bounce\" style=\"animation-delay:150ms;\"></span><span class=\"w-2 h-2 bg-gray-400 rounded-full animate-bounce\" style=\"animation-delay:300ms;\"></span></div></div>", 2)
                                ]))]))
                            : _createCommentVNode("", true)
                    ], 64))
            ], 544));
        };
    }
});
